<template>
  <section id="HomeServiceSection" ref="MainContent">
    <div class="main_container">
      <ol class="service_list">
        <li
          class="service_item"
          data-card-item
          v-for="(item, itemIndex) in serviceList"
          :key="`service_${itemIndex}`"
        >
          <div class="card">
            <div class="image_box">
              <img :src="item.image" />
            </div>
            <div class="text_box">
              <h5>{{ item.title }}</h5>
              <p class="textarea_content">
                {{ item.content }}
              </p>
            </div>
          </div>
        </li>
      </ol>
    </div>
  </section>
</template>

<script>
import { ServiceSection } from "@/animations/home/serviceSection.js";
export default {
  name: "HomeServiceSection",
  data() {
    return {
      animation: null,
    };
  },
  methods: {
    InitAnimation() {
      this.animation = new ServiceSection(this.$refs.MainContent);
      this.animation.Reset();
    },
    SetAnimation() {
      // this.animation.Setup();
    },
  },
  computed: {
    serviceList() {
      let serviceList = [];
      for (let i = 1; i <= 4; i++) {
        let serviceItem = {
          title: this.$store.getters.columnData(`service_${i}_title`),
          content: this.$store.getters.columnData(`service_${i}_content`),
          image: this.$store.getters.imageUrl(
            this.$store.getters.columnData(`service_${i}_image`)
          ),
        };
        serviceList.push(serviceItem);
      }
      return serviceList;
    },
  },
  mounted() {
    // this.InitAnimation();
  },
};
</script>
